<template>
    <div class="noti-cn" v-show="showNoti">
    <p class="noti" >
        <span class="p-1">
            <Icon icon="bxs:comment-error" />
        </span>
      คำแนะนำ: หากต้องการให้รถขนส่งเข้ารับพัสดุภายในวัน “ควรสร้างรายการอย่างน้อย
      1 รายการ ก่อนเวลาตัดรอบอย่างน้อย 30 นาที”
      <span @click="saveCookie()" class="noti-icon">
        <Icon icon="akar-icons:circle-x-fill" />
      </span>
    </p>
  </div>
  
</template>
<script>
import { getCookie } from "@/helpers/util"
export default {
    data(){
        return{
            showNoti : true,
        }
    },
  methods: {
    saveCookie() {
       let id = JSON.parse( localStorage.getItem('user'))
      document.cookie = "noti=" + id.dealer_id + ";path=/";
      this.showNoti = false;
    },
    checkCookie() {
      let user = getCookie("noti");
      if (user != "") { 
        this.showNoti = false;
      } else {
        return 0;
      }
    },
    checkTheme(){
        return ['shipsbuy'].includes(this.$THEME.name)
    }
  },
  mounted(){
    this.checkCookie();
  }
};
</script>